import { render, staticRenderFns } from "./ViewReports.vue?vue&type=template&id=fabb534e&"
import script from "./ViewReports.vue?vue&type=script&lang=js&"
export * from "./ViewReports.vue?vue&type=script&lang=js&"
import style0 from "./ViewReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports